import React from 'react';
import '../../public/scss/about.scss';

const Footer = () => {
    return (
        <footer className="footer">
            <div>
                <div className="block-about">
                    <div className="block-about__top">
                        <div className="block-about__description">
                            <div className="block-about__title heading">
                                We are&nbsp;
                                <span>Allstate Benefits</span>
                            </div>
                            <div className="block-about__text">
                                From innovative group health coverage to our industry-leading range of
                                comprehensive supplementary insurance, we believe everyone should have the option
                                of quality, affordable insurance, from a company they trust.
                            </div>
                            <a href="https://www.allstate.com/allstate-benefits/about-us.aspx" rel="noopener noreferrer" target="_blank" className="d-inline-block text--styled-link mt-3 block-about__more">Learn more about us</a>
                        </div>
                        <div className="block-about__bbb">
                            <span className="block-about__bbb_whitehands" />
                        </div>
                    </div>
                    <div className="block-about__bottom">
                        <div className="block-about__allstate">
                            <span className="block-about__bottom-logo" />
                        </div>
                        <div className="footer__links">
                            <ul className="footer__menu">
                                <li className="footer__menu-item">
                                    <a href="https://www.allstate.com/allstate-benefits/terms-of-use.aspx" rel="noopener noreferrer" target="_blank" className="footer_menu-link">Terms of use&nbsp;</a>
                                    <span className="footer__link-divider">|</span>
                                </li>
                                <li className="footer__menu-item">
                                    <a href="https://www.allstate.com/allstate-benefits/privacy-and-security.aspx" target="_blank" rel="noopener noreferrer" className="footer_menu-link">Privacy &amp; security&nbsp;</a>
                                    <span className="footer__link-divider">|</span>
                                </li>
                                <li className="footer__menu-item">
                                    <a href="https://www.allstate.com/allstate-benefits/california-consumer-privacy.aspx" target="_blank" rel="noopener noreferrer" className="footer_menu-link"> California Consumer Privacy</a>
                                </li>
                            </ul>
                        </div>
                        <div className="block-about__g-hands">
                            <div className="block-about__bottom-text">
                                <span className="bottom-text">you’re in</span>
                                <span className="bottom-text-good-hands">good hands®</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer__inner">
                    <div className="footer__copyright">
                        © 2023 Allstate Insurance Company, All rights reserved
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
